
{
  "fr": {
    "configuratorCrossSellModalHeader": {
      "advertisment": "Vos gobelets existent dans d'autres formats ! Complétez votre commande et économisez :",
      "promotionTag": {
        "text5": "2 formats achetés =",
        "reduction5": "-5%",
        "text10": "3 formats achetés =",
        "reduction10": "-10%"
      }
    }
  }
}
